import { Box, Typography, Container, Paper, Link } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

export const ContactFavela = () => {
    return (
        <Container
            maxWidth="md"
            sx={{
                py: { xs: 2, md: 4 },
                minHeight: "100vh",
                display: "flex",
                alignItems: { xs: "flex-start", md: "center" },
                justifyContent: "center",
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: { xs: 2, md: 6 },
                    borderRadius: 2,
                    textAlign: "center",
                    maxWidth: "600px",
                    width: "100%",
                    mt: { xs: 1, md: 0 },
                }}
            >
                <Typography
                    variant="h3"
                    component="h1"
                    gutterBottom
                    sx={{
                        color: "var(--primary-color)",
                        fontWeight: "bold",
                        mb: 3,
                    }}
                >
                    Contato
                </Typography>

                <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    sx={{
                        color: "var(--grey-800-color)",
                        mb: 4,
                    }}
                >
                    Favela Gaming
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: "var(--grey-700-color)",
                        mb: 3,
                        lineHeight: 1.6,
                    }}
                >
                    Precisa de ajuda ou tem alguma dúvida sobre nossa plataforma? 
                    Entre em contato e nossa equipe terá prazer em te ajudar!
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: "var(--grey-700-color)",
                        mb: 4,
                        lineHeight: 1.6,
                    }}
                >
                    Estamos sempre prontos para apoiar sua jornada no Cria de Quebrada.
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 2,
                        p: 3,
                        bgcolor: "var(--grey-50-color)",
                        borderRadius: 2,
                        mb: 3,
                    }}
                >
                    <EmailIcon
                        sx={{
                            color: "var(--primary-color)",
                            fontSize: 32,
                        }}
                    />
                    <Link
                        href="mailto:favelagaming@finallevel.com.br"
                        sx={{
                            fontSize: "1.2rem",
                            fontWeight: "bold",
                            color: "var(--primary-color)",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline",
                            },
                        }}
                    >
                        favelagaming@finallevel.com.br
                    </Link>
                </Box>

                <Typography
                    variant="body2"
                    sx={{
                        color: "var(--grey-600-color)",
                        fontStyle: "italic",
                    }}
                >
                    Clique no email acima para abrir seu cliente de email automaticamente
                </Typography>
            </Paper>
        </Container>
    );
};
